import api from './api';

export const getAreas = async (params = {}) => {
  const response = await api.get('/configuration/areas', { params });
  return response.data;
};

export const getArea = async (id) => {
  const response = await api.get(`/configuration/areas/${id}`);
  return response.data;
};

export const createArea = async (data) => {
  const response = await api.post('/configuration/areas', data);
  return response.data;
};

export const updateArea = async (id, data) => {
  const response = await api.put(`/configuration/areas/${id}`, data);
  return response.data;
};

export const deleteArea = async (id) => {
  const response = await api.delete(`/configuration/areas/${id}`);
  return response.data;
};
